import { render, staticRenderFns } from "./productGradePrice.vue?vue&type=template&id=7482f88f&scoped=true&"
import script from "./productGradePrice.vue?vue&type=script&lang=js&"
export * from "./productGradePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7482f88f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/meiyeJinHuo/meiyeJinHuoAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7482f88f')) {
      api.createRecord('7482f88f', component.options)
    } else {
      api.reload('7482f88f', component.options)
    }
    module.hot.accept("./productGradePrice.vue?vue&type=template&id=7482f88f&scoped=true&", function () {
      api.rerender('7482f88f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/product/proManage/productGradePrice.vue"
export default component.exports